import React from 'react';
import styles from './FlyoutMenuItem.scss';
import { notifyAnalytics } from '../notify-analytics';
import { formatTestId } from '../../../utils/test-id/format-testid';
import { Image } from '../Image/Image';

type FlyoutMenuItemProps = {
  label: string;
  url: string;
  hierarchy: string;
  imageUrl?: string;
};

export const FlyoutMenuItem = ({
  label,
  url,
  hierarchy,
  imageUrl,
}: FlyoutMenuItemProps) => {
  const navigate = () => {
    const navigationPath = hierarchy.endsWith(`|${label}`)
      ? hierarchy
      : `${hierarchy}|${label}`;

    notifyAnalytics(navigationPath);
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLAnchorElement>) => {
    if (e.key === 'Tab' || e.key === 'Escape') {
      return;
    }

    e.stopPropagation();
  };

  return (
    <li className={styles.flyoutMenuItem}>
      <a
        href={url}
        aria-label={imageUrl ? label : undefined}
        onClick={navigate}
        onKeyDown={handleKeyDown}
        data-testid={`${formatTestId(label, 'nav-')}`}
      >
        {imageUrl ? (
          <Image width={145} height={67} url={imageUrl} label={label} />
        ) : (
          label
        )}
      </a>
    </li>
  );
};
